import { createSelector } from 'reselect'

const createIsCardObservedSelector = () => createSelector<any, any, any, boolean>(
  [
    (_, { cardId }) => cardId,
    state => state.kanbo.observedTags,
  ],
  (
    cardId,
    observedTags,
  ) =>
    observedTags.some(tag => tag === `card-${cardId}`)
)

export default createIsCardObservedSelector
